import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';

import AllIcon from './AllIcon';

function AllButton() {
    return (
        <Link activityName='OrderLogsActivity'
            activityParams={{ duration: 'WEEK' }}>
            <Container align='center' spacing={6}>
                <AllIcon/>
                <Label>
                    <Text color={colors.white}>
                        전체보기
                    </Text>
                </Label>
            </Container>
        </Link>
    );
}

const Container = styled(Column)`
    margin-left: 8px;
`;

const Label = styled.div`
    background-color: var(--color-gray6);
    border-radius: 20px;
    padding: 3px 10px;
`;

export default AllButton;
